import React from "react";
import Sidebar from "./Sidebar";

const Layout = (props) => {
  return (
    <div style={{ paddingLeft: "60px", paddingRight: "20px" }}>
      <Sidebar />
      <div className="container">{props.children}</div>
    </div>
  );
};

export default Layout;
